import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import Team1Image from "../../assets/images/team-1.png";
import DinkyImage from "../../assets/images/HappyClientImages/Dinky.jpeg";
import KunalImage from "../../assets/images/HappyClientImages/KunalMunjal.jpg";
import priyankaAnsal from "../../assets/images/HappyClientImages/Priynkaansal.jpg";
import Priyanka from "../../assets/images/HappyClientImages/priyanka lohia.jpg";
import Tahil from "../../assets/images/HappyClientImages/tahil.jpeg";
import Ridhi from "../../assets/images/HappyClientImages/ridhi.jpeg";
import Tarun from "../../assets/images/HappyClientImages/tarun.jpg";
import Sudhanshu from "../../assets/images/HappyClientImages/sudhanshu.jpeg";
import Prince from "../../assets/images/HappyClientImages/prince makkar.jpeg";
import Sachin from "../../assets/images/sachinnarang.png";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const OurHappyClient = () => {
    const clients = [
        {
            name: "Kunal Munjal",
            city: "Panipat",
            image: KunalImage,
            review: "Atta is good and better than Aashirwad Atta. I suggest everyone should give Moolchand Atta a try at least once."
        },
        {
            name: "Dinky",
            city: "Panipat",
            image: DinkyImage,
            review: "Fresh flour with great taste. The rotis stay soft for hours. Totally worth it."
        },
        {
            name: "Pryanka",
            city: "Ansal,Panipat",
            image: priyankaAnsal,
            review: "The quality is excellent and you can actually feel the freshness. Home delivery was also on time."
        },
        {
            name: "Priyanka Lohia",
            city: "Sanoli road,Panipat",
            image: Priyanka,
            review: "I loved the option to customize the flour as per my family's needs. The taste and aroma are much better than packaged atta."
        },
        {
            name: "Tahil",
            city: "Sector 13-17,Panipat",
            image: Tahil,
            review: "This has become our regular choice. Fresh grinding makes a noticeable difference in the softness of rotis."
        },
        {
            name: "Ridhi",
            city: "Model Town,Panipat",
            image: Ridhi,
            review: "Very clean packaging, fresh flour and excellent customer service. Highly recommended."
        },
        {
            name: "Sachin Narang",
            city: "Panipat",
            image: Sachin,
            review: "The taste reminds me of freshly ground atta from traditional chakkis. Great experience overall."
        },
        {
            name: "Tarun Kataria",
            city: "AU Bank, Sanjay Chowk, Panipat",
            image: Tarun,
            review: "I switched from branded packaged atta and the difference was visible from the very first meal. Freshness is unmatched."
        },
        {
            name: "Sudhanshu",
            city: "11-12 Sec, Panipat",
            image: Sudhanshu,
            review: "Ordering was simple, delivery was quick and the quality exceeded my expectations. Will definitely order again."
        },
        {
            name: "Prince Makkar",
            city: "Pink Cosmetics, Sector 11, Panipat",
            image: Prince,
            review: "The flour smells fresh, tastes natural and makes very soft rotis. My family loved it."
        }
    ];
    return (
        <>
            <Swiper
                modules={[Navigation, Pagination, A11y]}
                spaceBetween={30}
                slidesPerView={3} // Show 3 slides at a time
                navigation
                pagination={{ clickable: true }}
                loop={true}
                breakpoints={{
                    320: {
                        slidesPerView: 1,
                    },
                    640: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                }}
            >

                {
                    clients.map((client, index) => (
                        <SwiperSlide key={index}>
                            <div className={'our-client-box'}>
                                <div className={'d-flex align-items-center mb_18'}>
                                    <div className="img-wrapper">
                                        <img src={client.image} alt={client.name} />
                                    </div>
                                    <h6 className={'fs_20 fw_700 text-color mb-0'}>{client.name}, {client.city}</h6>
                                </div>
                                <p className={'fs_20 fw_400 lh-1-5 mb-0 text-color'}>{client.review}</p>
                            </div>
                        </SwiperSlide>
                    ))
                }
            </Swiper>
        </>
    );
};

export default OurHappyClient;
